import { render, staticRenderFns } from "./CrudGoalsList.vue?vue&type=template&id=477424ea&"
import script from "./CrudGoalsList.vue?vue&type=script&lang=js&"
export * from "./CrudGoalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports